/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  failedUpdateTitle: {
    id: 'organization.security.role-mapping.role-mapping-verification-failed-update-title',
    defaultMessage: 'Verification failed',
  },
  failedDeleteTitle: {
    id: 'organization.security.role-mapping.role-mapping-verification-failed-delete-title',
    defaultMessage: 'The role mapping {roleMappingName} cannot be deleted',
  },
  successUpdateTitle: {
    id: 'organization.security.role-mapping.role-mapping-verification-success-update-title',
    defaultMessage: 'Verification succeeded',
  },
  failedUpdateDescription: {
    id: 'organization.security.role-mapping.role-mapping-verification-failed-update-description',
    defaultMessage:
      'The role mapping verification was not successful. At least one Organization Owner role must be mapped to the groups returned in the SAML response. Edit the role mapping or modify your IdP groups, then run the test again.',
  },
  failedDeleteDescription: {
    id: 'organization.security.role-mapping.role-mapping-verification-failed-delete-description',
    defaultMessage: `The role mapping {roleMappingName} can't be deleted because it is the only role mapping that is mapped to the Organization owner role. Create or edit another role mapping, or modify your IdP groups and try again.`,
  },
  successUpdateDescription: {
    id: 'organization.security.role-mapping.role-mapping-verification-success-update-description',
    defaultMessage:
      'The Organization owner role was successfully mapped from the groups in the SAML response. You can now safely save the role mapping.',
  },
  mappingRoles: {
    id: 'organization.security.role-mapping.role-mapping-verification-mapping-roles',
    defaultMessage: 'Mapped roles:',
  },
  verifyDetails: {
    id: 'organization.security.role-mapping.role-mapping-verification-verify-details',
    defaultMessage: 'Verify that the rest of the details are correct.',
  },
  email: {
    id: 'organization.security.role-mapping.role-mapping-verification-email',
    defaultMessage: 'Email: {email}',
  },
  idpGroup: {
    id: 'organization.security.role-mapping.role-mapping-verification-idp-groups',
    defaultMessage: 'IDP groups: {idpGroups}',
  },
  name: {
    id: 'organization.security.role-mapping.role-mapping-verification-name',
    defaultMessage: 'Name: {name}',
  },
  none: {
    id: 'organization.security.role-mapping.role-mapping-verification-none',
    defaultMessage: 'None',
  },
})
